<template>
  <div id="pageComplain" v-if="detailLoaded">
    <v-container grid-list-xl fluid>
      <v-card>
        <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
          <!-- Danh sách sản phẩm -->
          <v-flex sm12 md12 lg8>
            <v-widget title="Danh sách sản phẩm khiếu nại">
              <div slot="widget-content">
                <v-data-table :headers="productHeader" :items="products" :mobile-breakpoint="100">
                  <template v-slot:item="{ item, index }">
                    <tr>
                      <td>
                        <a target="blank" :href="item.link_origin">{{ item.ID }}</a>
                      </td>
                      <td>
                        <img class="image-product" :src="formatProductImage(item.image_origin)" alt />
                      </td>
                      <td>{{ item.property }}</td>
                      <td class="text-end">{{ item.quantity }}</td>
                      <td class="text-end">{{ item.price_promotion | currency('¥', 2) }}</td>
                      <td
                        class="text-end"
                      >{{ item.quantity*item.price_promotion | currency('¥', 2) }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </v-widget>
          </v-flex>
          <v-flex sm12 md12 lg4>
                <v-widget title="Chat box">
                    <div slot="widget-content">
                        <message-box :orderId="Number(complainId)" :orderType="4"></message-box>
                    </div>
                </v-widget>
          </v-flex>
          <v-flex sm12 md12 lg12>
            <v-widget title="Nội dung chi tiết">
            <template slot="widget-content">
              <v-layout row wrap>
                <v-flex lg6 md6 sm12>
                  <v-text-field
                    label="Khách hàng"
                    v-model="currentComplain.Username"
                    class="input-group--focused"
                    disabled
                  ></v-text-field>
                  <v-text-field
                    label="Mã đơn hàng"
                    v-model="currentComplain.OrderID"
                    class="input-group--focused"
                    disabled
                  ></v-text-field>
                  <h-currency-input
                    v-model="currentComplain.AmountNDT"
                    :disabled="isFinished || !adminRole"
                    :decimal="2"
                    label="Số tiền (¥)"
                    class="input-group--focused"
                    @input="currentComplain.Amount = currentComplain.AmountNDT * currentComplain.ExchangeRate"
                  ></h-currency-input>
                  <h-currency-input
                    :disabled="isFinished || !adminRole"
                    v-model="currentComplain.ExchangeRate"
                    :decimal="0"
                    label="Tỷ giá"
                    class="input-group--focused"
                    @input="currentComplain.Amount = currentComplain.AmountNDT * currentComplain.ExchangeRate"
                    :rules="requireRules"
                  ></h-currency-input>
                  <h-currency-input
                    disabled
                    v-model="currentComplain.Amount"
                    :decimal="0"
                    label="Số tiền (vnđ)"
                    class="input-group--focused"
                  ></h-currency-input>
                </v-flex>
                <v-flex lg6 md6 sm12>
                  <p>Nội dung khiếu nại</p>
                  <v-checkbox disabled label="Thiếu hàng" v-model="currentComplain.IsMissGood"></v-checkbox>
                  <v-checkbox disabled label="Hàng bị hỏng" v-model="currentComplain.IsBroken"></v-checkbox>
                  <v-checkbox
                    disabled
                    label="Sai tùy chọn (mầu, size)"
                    v-model="currentComplain.IsOption"
                  ></v-checkbox>
                  <v-checkbox disabled label="Khác" v-model="currentComplain.IsOther"></v-checkbox>
                </v-flex>
                <v-flex lg12 md12 sm12 pb-0 class="d-flex align-center justify-space-between">
                  <p class="ma-0 font-weight-bold">Hình ảnh</p>
                  <div v-if="!isFinished">
                    <input type="file" ref="r2Uploader" style="display: none" @change="uploadR2Image" accept="image/*" multiple />
                    <v-btn small color="primary" @click="$refs.r2Uploader.click()" :loading="uploadingR2">
                      <v-icon left small>cloud_upload</v-icon> Tải ảnh lên
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex lg12 md12 sm12 pt-0>
                  <gallery :images="images" :index="imgIndex" @close="imgIndex = null"></gallery>
                  <div v-if="images.length > 0" class="d-flex flex-wrap">
                    <div
                      class="image-container"
                      v-for="(image, imageIndex) in images"
                      :key="imageIndex"
                    >
                      <div
                        class="image"
                        @click="imgIndex = imageIndex"
                        :style="{ backgroundImage: 'url(' + image + ')', width: '300px', height: '200px' }"
                      ></div>
                      <v-btn
                        v-if="!isFinished"
                        icon
                        small
                        color="error"
                        class="remove-image-btn"
                        @click.stop="removeImage(imageIndex)"
                        title="Xóa ảnh"
                      >
                        <v-icon small>delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                  <div v-else class="grey--text text--darken-1 font-italic py-2">
                    Không có hình ảnh đính kèm
                  </div>
                </v-flex>
                <v-flex lg12 md12 sm12 pt-0>
                  <v-textarea
                    disabled
                    auto-grow
                    label="Nội dung"
                    v-model="currentComplain.ComplainText"
                    class="input-group--focused"
                  ></v-textarea>
                </v-flex>
                <v-flex lg12 md12 sm12 pt-0>
                  <v-textarea
                    label="Ghi chú của nhân viên"
                    :disabled="isFinished"
                    v-model="currentComplain.NoteOfStaff"
                    class="input-group--focused"
                  ></v-textarea>
                </v-flex>
                <v-flex lg12 md12 sm12 pt-0>
                  <v-textarea
                    label="Ghi chú cho khách hàng"
                    :disabled="isFinished"
                    v-model="currentComplain.NoteForUser"
                    class="input-group--focused"
                  ></v-textarea>
                </v-flex>
                <v-flex lg12 md12 sm12>
                  <v-select
                    :disabled="isFinished"
                    v-model="editStatus"
                    :items="complain_status_list"
                    item-text="name"
                    item-value="value"
                  ></v-select>
                  <v-alert
                    v-if="!isFinished && editStatus === complain_status.Finished && !isAccountantOrAdmin"
                    dense
                    outlined
                    type="warning"
                    class="mt-2 mb-0"
                  >
                    Tài khoản của bạn không thuộc quyền Kế toán / Admin. Khi kết thúc khiếu nại, hệ thống sẽ <strong>không hoàn tiền vào ví</strong> cho khách hàng.
                  </v-alert>
                  <v-alert
                    v-else-if="!isFinished && editStatus === complain_status.Finished && isAccountantOrAdmin"
                    dense
                    outlined
                    type="info"
                    class="mt-2 mb-0"
                  >
                    Khi kết thúc khiếu nại, số tiền <strong>{{ (currentComplain.Amount || 0) | currency('', 0) }} vnđ</strong> sẽ được <strong>hoàn trực tiếp vào ví</strong> của khách hàng.
                  </v-alert>
                </v-flex>
                <v-layout class="d-flex">
                    <v-flex lg12>
                        <v-btn v-if="!isFinished" class="align-right" color="#dc3545" dark @click="saveData">
                            Lưu lại
                        </v-btn>
                    </v-flex>
                </v-layout>
              </v-layout>
            </template>
            </v-widget>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import VueGallery from "vue-gallery";
import VWidget from "@/components/VWidget";
import MessageBox from "@/components/chat/MessageBox";
export default {
  components: {
    gallery: VueGallery,
    VWidget,
    MessageBox
  },
  data() {
    return {
      detailLoaded: false,
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      complain_status: configs.COMPLAIN_STATUS,
      complain_status_list: configs.COMPLAIN_STATUS_LIST,
      editStatus: 1,
      imgIndex: null,
      uploadingR2: false,
      productHeader: [
        {
          text: "ID",
          value: "ID",
          sortable: false
        },
        {
          text: "Ảnh",
          value: "image_origin",
          sortable: false
        },
        {
          text: "Thuộc tính",
          value: "property",
          sortable: false
        },
        {
          text: "Số lượng",
          value: "quantity",
          align: "end",
          sortable: false
        },
        {
          text: "Giá (¥)",
          value: "price_promotion",
          align: "end",
          sortable: false
        },
        {
          text: "Thành tiền (¥)",
          value: "total",
          align: "end",
          sortable: false
        }
      ]
    };
  },
  computed: {
    ...mapState("complain", {
      loading: "loading",
      currentComplain: "selected"
    }),
    ...mapState({
      products: state => state.complain.selected.Products
    }),
    complainId() {
      return this.$route.params.Pid;
    },
    images() {
      var listOfImg = this.currentComplain.IMG
        ? this.currentComplain.IMG.split(";").filter(Boolean)
        : [];
      return listOfImg.map(img => {
        if (!img) return '';
        if (img.startsWith('http://') || img.startsWith('https://') || img.startsWith('//')) {
          return img;
        }
        return `${configs.SYSTEM_CONFIG.firebase_storage}/${configs.SYSTEM_CONFIG.firebase_prefix}%2Fcomplain%2F${img}?alt=media`;
      }).filter(Boolean);
    },
    isAccountantOrAdmin() {
      const user = this.$store.state.authentication.user;
      const roletype = (user && user.roletype) || 0;
      return (roletype & configs.ROLE_TYPE.Admin) === configs.ROLE_TYPE.Admin ||
             (roletype & configs.ROLE_TYPE.Payment) === configs.ROLE_TYPE.Payment;
    },
    adminRole() {
      return this.isAccountantOrAdmin;
    },
    isFinished() {
      return Number(this.currentComplain.Status) === this.complain_status.Finished;
    }
  },
  watch: {
    currentComplain() {
      this.editStatus = this.currentComplain.Status;
      this.updatePageOptions();
    }
  },
  methods: {
    refreshData() {
      this.detailLoaded = false;
      if (this.complainId > 0) {
        this.$store.commit("complain/setDetail", {data: {}});
        this.$store.dispatch("complain/getDetail", {
          id: this.complainId,
          onSuccess: () => {
            this.detailLoaded = true;
          },
          onError: err => {
            if (err && (err.status === 403 || err.status === 404)) {
              this.$router.replace({ name: 'DataNotFound' });
            }
          }
        });
      }
    },
    saveData() {
      if (this.isFinished) {
        return;
      }
      this.currentComplain.Status = this.editStatus;
      this.updatePageOptions();
      this.$store.dispatch("complain/setDetail", this.currentComplain);
    },
    updatePageOptions() {
      this.$root.$emit('REQUEST_ROOT_OPTION', {
        invisibleSaveButton: this.isFinished
      });
    },
    formatProductImage(img) {
      if (!img) return '';
      if (img.startsWith('http://') || img.startsWith('https://') || img.includes('firebase') || img.includes('r2')) {
        return img;
      }
      try {
        return decodeURIComponent(img);
      } catch (e) {
        return img;
      }
    },
    removeImage(index) {
      const rawList = this.currentComplain.IMG ? this.currentComplain.IMG.split(";").filter(Boolean) : [];
      if (index >= 0 && index < rawList.length) {
        rawList.splice(index, 1);
        this.$set(this.currentComplain, 'IMG', rawList.join(";"));
      }
    },
    uploadR2Image(e) {
      const files = e.target.files;
      if (!files || !files.length) return;
      this.uploadingR2 = true;
      const uploadPromises = Array.from(files).map(file => {
        let formData = new FormData();
        formData.append("file", file);
        return this.$http
          .post(`${configs.API || ""}/admin/api/upload/r2/`, formData, {
            headers: { Authorization: "Bearer " + this.$store.state.authentication.token }
          })
          .then(res => {
            if (res.data.status === 200 && res.data.data && res.data.data.url) {
              return res.data.data.url;
            }
            return null;
          })
          .catch(() => null);
      });

      Promise.all(uploadPromises).then(urls => {
        this.uploadingR2 = false;
        const validUrls = urls.filter(Boolean);
        if (validUrls.length > 0) {
          const existing = this.currentComplain.IMG ? this.currentComplain.IMG.split(";").filter(Boolean) : [];
          const updated = existing.concat(validUrls);
          this.$set(this.currentComplain, 'IMG', updated.join(";"));
          window.getApp.$emit("SHOW_NOTICE", "Upload ảnh thành công!", "success");
        } else {
          window.getApp.$emit("SHOW_NOTICE", "Upload ảnh thất bại.", "error");
        }
        if (this.$refs.r2Uploader) {
          this.$refs.r2Uploader.value = "";
        }
      });
    }
  },
  mounted() {
    this.refreshData();
    this.$root.$emit('REQUEST_ROOT_OPTION', {});
    this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    this.$root.$emit('REQUEST_ROOT_OPTION', {});
  }
};
</script>

<style scoped>
.image-container {
  position: relative;
  display: inline-block;
  margin: 5px;
}
.image {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  cursor: pointer;
}
.remove-image-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(255, 255, 255, 0.85) !important;
}
.image-product {
  width: 64px;
}
.align-right{
  float: right;
  margin: 5px;
}
</style>
